import {
	LOGIN_REQUEST,
	LOGIN_FAILURE,
	LOGIN_SUCCESS,
	LOGOUT,
	LOGIN_AZURE,
	GET_USERS_LIST,
	REQUEST_LOGIN_AZURE,
	GET_CONCURRENT_USERS,
	ERROR_USER,
	UPDATE_NEW_TOKEN,
	LOGOUT_CLEAR_STORE,
	AZUREAD_LOGIN_URL_REQUEST,
	AZUREAD_LOGIN_URL_REQUEST_SUCCESS,
	AZUREAD_LOGIN_URL_REQUEST_FAILURE,
	AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR,
	AZUREAD_LOGIN_REQUEST,
	AZUREAD_LOGIN_SUCCESS,
	AZUREAD_LOGIN_FAILURE,
	GET_USERS_LIST_REQUEST,
	GET_USERS_LIST_SUCCESS,
	GET_USERS_LIST_FAILED,
	GET_USERS_LIST_RESET,
	LOGOUT_USER,
	LOGOUT_USER_SUCCESS,
	LOGOUT_USER_FAILURE,
	FORGET_PASSWORD,
	FORGET_PASSWORD_FAIL,
	FORGET_PASSWORD_SUCCESS,
	FORGET_PASSWORD_RESET,
	RESET_PASSWORD,
	RESET_PASSWORD_FAIL,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_RESET,
	REDIRECT_TO_HOME,
} from "../types"

export const startingAzuleLogin = (estado) => ({
	type: LOGIN_AZURE,
	payload: estado,
})

export const requestUser = (username, password = null) => ({
	type: LOGIN_REQUEST,
	payload: {
		username: username,
		password: password,
	},
})

export const failureUser = (error) => ({
	type: LOGIN_FAILURE,
	payload: error,
})

export const logoutUser = () => ({
	type: LOGOUT,
	payload: null,
})

export const loginAzure = (oid, name, username) => ({
	type: REQUEST_LOGIN_AZURE,
	payload: {
		oid: oid,
		name: name,
		username: username,
	},
})

export const getConcurrentUsers = () => ({
	type: GET_CONCURRENT_USERS,
})

export const errorUser = () => ({
	type: ERROR_USER,
})

export const updateToken = (data) => ({
	type: UPDATE_NEW_TOKEN,
	payload: data,
})

export const logoutClearStore = () => ({
	type: LOGOUT_CLEAR_STORE,
})

//AzureAd login URL request
export const azureAdGetLoginUrl = () => ({
	type: AZUREAD_LOGIN_URL_REQUEST,
})

export const azureAdGetLoginUrlSuccess = (data) => ({
	type: AZUREAD_LOGIN_URL_REQUEST_SUCCESS,
	payload: data,
})

export const azureAdGetLoginUrlFailed = (data) => ({
	type: AZUREAD_LOGIN_URL_REQUEST_FAILURE,
	payload: data,
})

export const azureAdGetLoginUrlFailedClear = () => ({
	type: AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR,
})

//AzureAd login request
export const azureAdLoginRequest = (data) => ({
	type: AZUREAD_LOGIN_REQUEST,
	payload: data,
})

export const azureAdLoginRequestSuccess = (data) => ({
	type: AZUREAD_LOGIN_SUCCESS,
	payload: data,
})

export const azureAdLoginRequestFailed = (data) => ({
	type: AZUREAD_LOGIN_FAILURE,
	payload: data,
})

export const azureAdLoginRequestFailedClear = () => ({
	type: AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR,
})

export const logoutUserAction = (payload) => ({
	type: LOGOUT_USER,
	payload,
})

export const logoutUserActionSuccess = (payload) => ({
	type: LOGOUT_USER_SUCCESS,
	payload,
})

export const logoutUserActionFailure = (payload) => ({
	type: LOGOUT_USER_FAILURE,
	payload,
})

export const forgotPasswordAction = (payload) => ({
	type: FORGET_PASSWORD,
	payload,
})

export const forgotPasswordSuccess = (payload) => ({
	type: FORGET_PASSWORD_SUCCESS,
	payload,
})

export const forgotPasswordFailure = (payload) => ({
	type: FORGET_PASSWORD_FAIL,
	payload,
})

export const resetPasswordAction = (payload) => ({
	type: RESET_PASSWORD,
	payload,
})

export const resetPasswordSuccess = (payload) => ({
	type: RESET_PASSWORD_SUCCESS,
	payload,
})

export const resetPasswordFailure = (payload) => ({
	type: RESET_PASSWORD_FAIL,
	payload,
})

export const redirectToHome = (payload) => ({
	type: REDIRECT_TO_HOME,
	payload,
})
